// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Widgets-FullText-FullTextsPreview-module__FullTextsPreview";
var _2 = "webpack-concepts-Extraction-Widgets-FullText-FullTextsPreview-module__preview";
var _3 = "webpack-concepts-Extraction-Widgets-FullText-FullTextsPreview-module__toolbar";
export { _1 as "FullTextsPreview", _2 as "preview", _3 as "toolbar" }
